import { useCallback, useEffect, useMemo } from 'react';

import { useMenu } from 'components/MenuContext/MenuContext';
import { NewCartItem, useCart } from 'hooks/context/cart';
import { useCloseNavigate } from 'hooks/useCloseNavigate/useCloseNavigate';
import { RouteFC } from 'util/routeTypes';
import { MenuItemModal } from './MenuItemModal';
import { useOrderHistory } from 'hooks/context/OrderHistory';

export const AddMenuItemModal: RouteFC<{ itemId: string }> = ({ path, itemId }) => {
  const { add } = useCart();
  const { menu, loading } = useMenu();
  const closeModal = useCloseNavigate(path);
  const { checkItemsWithUnavailableModifiers } = useOrderHistory();

  const menuItem = useMemo(() => itemId && menu?.items[itemId], [menu, itemId]);

  const handleSubmit = useCallback((cartItem)=>{
    //if an item with missing modifiers gets added to the cart, clear it from the list of unavailable items
    checkItemsWithUnavailableModifiers(cartItem);
    add(cartItem);
  }, [add, checkItemsWithUnavailableModifiers]);

  useEffect(() => {
    if (loading || (menu && menuItem)) return;

    closeModal();
  }, [closeModal, loading, menu, menuItem]);

  if (!menu || loading || !menuItem) return null;

  return <MenuItemModal<NewCartItem> menuItem={menuItem} onClose={closeModal} onSubmit={handleSubmit} />;
};
